import React from "react";

function CopyIcon() {
  return (
    <span className="anticon ant-copy">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="1em"
        height="1em"
        viewBox="0 0 20 20"
      >
        <path
          fill="currentColor"
          fillRule="evenodd"
          d="M18 0c1.152 0 2 .848 2 2v10c0 1.152-.848 2-2 2h-4v4c0 1.152-.848 2-2 2H2c-1.152 0-2-.848-2-2V8c0-1.152.848-2 2-2h4V2c0-1.152.848-2 2-2h10zM6 8H2v10h10v-4H8c-1.152 0-2-.848-2-2V8zm12-6H8v10h10V2z"
        ></path>
      </svg>
    </span>
  );
}

export default CopyIcon;
